<template>
  <div style="display: flex;align-items: center;padding: 10px;border: 1px solid #ccc;margin-top: 10px;">
    <dateTimePickerN :is-future="isFuture" v-model="date[0]"></dateTimePickerN>——<dateTimePickerN  v-model="date[1]"></dateTimePickerN>
  </div>
</template>

<script>
import dateTimePickerN from "./dateTimePickerN";
export default {
  name: "timePickerGroup",
  props: {
    value: {
    },
    isFuture: {
      default: false,
    },
  },
  data() {
    return {
      valueAfter: this.value,
      date:[
        {
          yearSelect:'',
          monthSelect:'',
          daySelect:''
        },
        {
          yearSelect:'',
          monthSelect:'',
          daySelect:''
        }
      ]
    }
  },
  watch: {
    value(val) {
      if(val) {
        this.valueAfter = val
      }
    },
    valueAfter: {
      handler(val) {
        if(val) {
          this.date = val
        }
      },
      deep: true,
      immediate: true
    },
    date(val) {
      let result = val.reduce((str,item,index) => {
        let resStr = `${item.yearSelect}-${item.monthSelect}-${item.daySelect}`
        console.log(resStr);
        str += resStr
        return str
      },"")
      console.log(result);
      this.$emit('input',val)
    }
  },
  components: {
    dateTimePickerN
  }
}
</script>

<style scoped>

</style>